import {
  ModalAction,
  ModalBody,
  ModalFooter,
  ModalFooterActions,
  ModalHeader,
  ModalV2,
  spaces,
  Text,
} from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type AlmostThereModalProps = {
  onClose: () => void;
};

const AlmostThereModal = ({ onClose }: AlmostThereModalProps) => {
  const { t } = useTranslation('common');

  return (
    <ModalV2 ariaLabelledby="almost-there-modal" hide={onClose} visible>
      <ModalHeader py={spaces.space_2xs}>
        <Text variant="heading-2">{t('almostThereModal.title')}</Text>
      </ModalHeader>
      <ModalBody px="5rem" py={spaces.space_s}>
        <Text textAlign="center">{t('almostThereModal.message')}</Text>
      </ModalBody>
      <ModalFooter py={spaces.space_m}>
        <ModalFooterActions>
          <ModalAction id="almost-there-modal-close">
            {t('almostThereModal.close')}
          </ModalAction>
        </ModalFooterActions>
      </ModalFooter>
    </ModalV2>
  );
};

export default AlmostThereModal;
